import { FormattedMessage, useIntl } from "react-intl";

import Heading from "@atlaskit/heading";
import {
    Anchor,
    Box,
    Flex,
    Stack,
    Text,
    xcss
} from "@atlaskit/primitives-next";

import { useRoutes } from "../../../hooks";
import { CautionVector } from "../../assets";

import { use404DisplayAnalytics } from "./hooks";
import { messages } from "./messages";

const iconContainerStyles = xcss({
    width: "180px",
    height: "180px"
});

export const FourOhFourDisplay = () => {
    const { paths } = useRoutes();
    const intl = useIntl();

    const { sendGoBackToHomeLinkClickUIEvent } = use404DisplayAnalytics();

    return (
        <Box padding="space.400">
            <Stack alignBlock="center" space="space.300" alignInline="center">
                <Flex
                    xcss={iconContainerStyles}
                    alignItems="center"
                    justifyContent="center"
                >
                    <CautionVector />
                </Flex>
                <Heading size="small">
                    <FormattedMessage {...messages.fourOhFourHeading} />
                </Heading>
                <Text>
                    <FormattedMessage
                        {...messages.fourOhFourDescription}
                        values={{
                            "404Link": (
                                <Anchor
                                    href={paths.home}
                                    onClick={() =>
                                        sendGoBackToHomeLinkClickUIEvent()
                                    }
                                >
                                    {intl.formatMessage(
                                        messages.fourOhFourLinkText
                                    )}
                                </Anchor>
                            )
                        }}
                    />
                </Text>
            </Stack>
        </Box>
    );
};
